var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
  let { isPhone, track_value, vu_logo_path, purpose, amount, credit_score, zip } = options; 
__p+='\n';
 let showPersonalLoan = (purpose === 'purchase' && amount < 100000) ? true : false 
__p+='\n<div class="no-rates-found padding-all-lg">\n  <div class="tip">\n    <div class="primary-text">We didn\'t find any results</div>\n    <div class="secondary-text">Don\'t be discouraged, here are some options:</div>\n  </div>\n  <hr>\n  <div class="tip-content">\n    ';
 if (showPersonalLoan) { 
__p+='\n        <div class="primary-text">Consider a Personal Loan</div>\n        <div class="secondary-text">For loan amounts less than $100k, consider a  <br/>personal loan instead of a mortgage</div>\n        <div class="cta-btn-container">\n         <a href="#" id="personal-loan-rates" class="btn btn-default home-loan-cta" data-toggle="modal">View personal loan rates</a>\n        </div>\n\n        <div class="divider">- OR -</div>\n     ';
 } 
__p+='\n    <div class="primary-text">Talk with a Lender</div>\n    <div class="secondary-text">Let us try to connect you with a lender for the best rates <br/>based on your profile</div>\n    <div class="cta-btn-container">\n      <a id="home-loan-cta" class="btn btn-default home-loan-cta" href="/mortgage/home-loan/?src=rates_table&iid=rates_table" target="_blank" rel=\'nofollow\'>Connect with a Lender</a>\n    </div>\n\n    <div class="divider">- OR -</div>\n\n    <div class="primary-text">Revisit your search criteria</div>\n    <div class="secondary-text">The top reasons for not finding results are low loan <br/>amounts, low down payments, and poor credit.</div>\n    <div class="cta-btn-container">\n      <a id="home-loan-cta" class="btn btn-default search-criteria-widget home-loan-cta">Adjust my search</a>\n    </div>\n    <hr>\n\n    '+
((__t=( JST['templates/mortgage/vu_native_ad']({
        isPhone,
        track_value,
        vu_logo_path
    }) ))==null?'':__t)+
'\n    ';
 if (showPersonalLoan) {
        let creditScore = { excellent: '740', good: '680', fair: '640', poor: '580' };
        let loanAmount = [1000, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 50000, 60000, 70000, 80000, 90000, 100000];
        let loan_amount = $.grep(loanAmount, function(value){ if (value >= amount) { return  value; }})[0];
        let url = "https://widgets.informars.com/c/standard/us/en/personalloan/tables/realtor/PersonalLoans.aspx?siteid=a9c5faa4155191cd&external=TABLE&zip=" + zip +"&credit_score=" + creditScore[credit_score] + "&loan_amount=" + loan_amount;
        
__p+='\n        '+
((__t=( JST['templates/mortgage/modal/index']({ url }) ))==null?'':__t)+
'\n    ';
 } 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_message.jst.ejs